import { render, staticRenderFns } from "./CopyRightGermanPage.vue?vue&type=template&id=5000aa32&scoped=true"
import script from "./CopyRightGermanPage.vue?vue&type=script&lang=ts"
export * from "./CopyRightGermanPage.vue?vue&type=script&lang=ts"
import style0 from "./CopyRightGermanPage.vue?vue&type=style&index=0&id=5000aa32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000aa32",
  null
  
)

export default component.exports